var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('SearchableTable',{attrs:{"panel-header":'ICD-10-Codes',"panel-route":'',"show-search-bar":true,"table-data":_vm.icd_10_codes,"table-meta-data":_vm.tableMetaData,"query-string":'setICD10CodeUnitSearchQuery',"event-value":_vm.parentEventValue}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }